import { gql } from "@apollo/client";

export default gql`
  query GetSlackConfiguration($organizationId: Int!) {
    organization(pk: $organizationId) {
      id
      publicSlackChannels(first: 250) {
        edges {
          node {
            id
            name
          }
        }
      }
      slackIndexingConfiguration {
        indexNewChannelsByDefault
        indexMessages
        channels {
          id
          name
          shouldIndex
          lastIndexedTs
          firstIndexedTs
        }
      }
    }
  }
`;
